import { FC } from 'react'

import { Translation } from 'cng-common/features/translations/components/translation'
import { Button } from 'core-components/library/button'

import { IAddNewContactButtonProps } from './models'

export const AddNewContactButton: FC<IAddNewContactButtonProps> = ({ onAddNewContactClick }) => (
  <Button margin={'sm'} variant={'contained'} color={'primary'} onClick={onAddNewContactClick}>
    <Translation text="partner-contacts_add-new" span />
  </Button>
)
